import React from 'react';
import Modal from './Modal';

export default function ConfirmModal({ isOpen, onClose, onConfirm, title, message, confirmText = 'Confirm', cancelText = 'Cancel', confirmColor = '#E53935', icon = '⚠️' }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title}>
      <div>
        <div style={{ textAlign: 'center', marginBottom: 20 }}>
          <div style={{ fontSize: 36, marginBottom: 10 }}>{icon}</div>
          <p style={{ fontSize: 14, color: '#3D4759', margin: 0, lineHeight: 1.6 }}>{message}</p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button 
            onClick={onClose} 
            style={{ 
              flex: 1, 
              padding: '10px 0', 
              background: '#F8F9FC', 
              color: '#5F6B80', 
              border: '1.5px solid #D8DDE8', 
              borderRadius: 8, 
              fontWeight: 600, 
              cursor: 'pointer', 
              fontSize: 13 
            }}
          >
            {cancelText}
          </button>
          <button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            style={{ 
              flex: 1, 
              padding: '10px 0', 
              background: confirmColor, 
              color: '#fff', 
              border: 'none', 
              borderRadius: 8, 
              fontWeight: 700, 
              cursor: 'pointer', 
              fontSize: 13 
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </Modal>
  );
}
